import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Combos/getComboGruposUsuario`, method: 'GET', body: null})
}